<template>
  <div>
    <router-view
      @copyUrlPrompt="onCopyUrlPrompt"
      @downloadByEmail="onDownloadByEmail"
    ></router-view>
    <van-dialog
      id="copy-url-dialog"
      v-model="showCopyUrlPrompt"
      title="提示"
      show-cancel-button
      confirm-button-text="复制"
      @confirm="onConfirmCopy"
    >
      <div class="dialog-content" style="padding: 10px 20px;">
        <div>复制下载链接在浏览器打开:</div>
        <div class="copy-url">{{ encodeURIComponent(copyUrl) }}</div>
      </div>
    </van-dialog>
    <van-dialog
      id="download-email-form-wap"
      v-model="showDownloadForm"
      title="文件下载"
      show-cancel-button
      confirm-button-text="提交"
      :before-close="beforeDownloadFormClose"
    >
      <div style="height: 80px; padding: 10px 0px;">
        <van-field
          class="email-input pxtovw-ignore"
          v-model="userEmail"
          label="邮箱: "
          placeholder="请输入邮箱地址"
          border
          :error-message="emailErrorMsg"
          @input="onInputEmail"
        />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { ck } from "fire-wind-water";
import { copyToClipboard, validateEmail } from "@/common/utils.js";
export default {
  name: "Wap",
  data() {
    return {
      // 复制链接
      showCopyUrlPrompt: false,
      copyUrl: "",

      // 邮箱下载表单
      showDownloadForm: false,
      userEmail: ck.cookie("user_email"),
      emailErrorMsg: "",
      downloadFile: {}
    };
  },
  methods: {
    // 复制链接
    onCopyUrlPrompt({ url }) {
      console.log("# onCopyUrlPrompt..");
      this.showCopyUrlPrompt = true;
      this.copyUrl = url;
    },
    onConfirmCopy() {
      copyToClipboard(this.copyUrl);
      this.$toast("复制成功");
      this.copyUrl = "";
    },

    // 邮箱下载
    onDownloadByEmail({ file }) {
      this.showDownloadForm = true;
      this.downloadFile = file;
      this.userEmail = ck.cookie("user_email");
    },
    beforeDownloadFormClose(action, done) {
      if (action === "confirm") {
        // 验证邮箱输入框
        if (!this.userEmail) {
          this.emailErrorMsg = "请填写邮箱";
          done(false);
          return;
        }
        if (validateEmail(this.userEmail)) {
          ck.cookie("user_email", this.userEmail);
          // 发送邮箱下载请求
          let tokenInfo = ck.cookie("verifyInfo_" + this.downloadFile.weChatId);
          let memberInfo = ck.cookie(
            "smarketMember_" + this.downloadFile.schemaId
          );
          let weChatId = this.downloadFile.weChatId || this.weChatId;
          this.service
            .downloadWithEmail({
              email: this.userEmail,
              fileList: [this.downloadFile.fileId],
              globalUserId: ck.cookie("globalUserId"),
              sess: memberInfo ? memberInfo.session : "",
              extra: {
                tenantId: this.downloadFile.tenantId,
                instanceId: this.downloadFile.instanceId,
                memberId: 0,
                moduleId: this.downloadFile.moduleId,
                openId: tokenInfo ? tokenInfo.original.openid : "",
                weChatId: weChatId ? weChatId : "",
                objInstanceId: "",
                source: "WAP",
                url: window.location.href
              }
            })
            .subscribe(data => {
              let msgSend = "文件已发送至邮箱";
              let msgReview = "审核通过后将发送至邮箱";
              let msgError = "提交异常";
              if (data.result != 0) {
                this.$toast.fail(msgError);
              } else if (data.content.isReview == 0) {
                this.$toast.success(msgSend);
              } else if (data.content.isReview == 1) {
                this.$vantDialog.alert({
                  title: "提示",
                  message: msgReview
                });
              }
              this.downloadFile = {};
              done();
            });
          // this.downloadFile = {}
          // done()
        } else {
          // 提示邮箱错误
          this.emailErrorMsg = "邮箱格式错误";
          done(false);
        }
      } else {
        this.emailErrorMsg = "";
        this.downloadFile = {};
        done();
      }
    },
    onInputEmail() {
      this.emailErrorMsg = "";
    }
  }
};
</script>

<style scoped>
.dialog-content .copy-url {
  max-height: 300px;
  min-height: 50px;
  color: rgb(33, 66, 128);
  overflow-y: auto;
  word-break: break-all;
}
.email-input.pxtovw-ignore >>> .van-field__label {
  width: 38px;
}
.email-input.pxtovw-ignore >>> input {
  padding: 0 4px;
  border: solid 1px rgba(230, 230, 230);
  border-radius: 4px;
}
.email-input >>> input:focus {
  border-color: rgb(33, 66, 128);
}
</style>
